import { useEffect } from 'react';
import { useRouter, useRouterParams } from '@americanexpress/one-app-router';
import { useSelector, useDispatch } from 'react-redux';
import { getUserWallet, getWalletError } from '@/selectors/walletSelector';
import { getIsLoggedIn } from '@/selectors/authSelectors';
import { setWalletIsRedirecting } from '@/slices/walletSlice';
import {
  pageSessionKey,
  redirectedSessionKey,
  loginPageValue,
} from '@/constants';

export const useBestCardRedirection = () => {
  const { product, locale } = useRouterParams();
  const wallet = useSelector(getUserWallet);
  const isWalletError = useSelector(getWalletError);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const dispatch = useDispatch();
  const router = useRouter();
  const bestCard = wallet?.[0];
  const bestCardName = bestCard?.loungeFinderProduct;
  const bestCardLocale = bestCard?.homeCountryLocale?.toLocaleLowerCase();

  useEffect(() => {
    if (
      isLoggedIn &&
      bestCard !== undefined &&
      !isWalletError &&
      typeof window !== 'undefined' &&
      (bestCardName !== product ||
        bestCardLocale !== locale?.toLocaleLowerCase()) &&
      window.sessionStorage.getItem(pageSessionKey) === loginPageValue
    ) {
      window.sessionStorage.setItem(redirectedSessionKey, '1');
      router.replace({
        pathname: `/${bestCardLocale}/travel/lounges/${bestCardName}`,
        query: router?.location?.query,
      });
    }

    // set wallet redirecting to false on the client (so we don't see page flicker)
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(pageSessionKey);
      dispatch(setWalletIsRedirecting(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run on initial render
  }, []);
};
